import { render, staticRenderFns } from "./TableAvenantArticle.vue?vue&type=template&id=1ef95597&scoped=true&"
import script from "./TableAvenantArticle.vue?vue&type=script&lang=js&"
export * from "./TableAvenantArticle.vue?vue&type=script&lang=js&"
import style0 from "./TableAvenantArticle.vue?vue&type=style&index=0&id=1ef95597&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef95597",
  null
  
)

export default component.exports